"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotGlobe = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotGlobe = _ref => {
  let {
    spotColor = "#a9acc4",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    d: "M-1-1h20v20H-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "nonzero",
    d: "M9 18a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9Zm3.482-16.053c-.13.328-.21.763-.01 1.2.404.885.171.868-.583 1.167-.754.298-.346-.299-1.167 0 0 0 .095.947 0 1.166-.095.22-.128 1.31-.583.584-.455-.726-1.027-.96-1.027-.96s-.284.033-.284.866c0 .602-1.123 1.272-1.023 1.844.1.572.048.627.387.875.123.09.186.48.197.876.015.605-.165.277.583.583.748.306.642.721 1.167 1.167.524.445.865-.035 1.166 1.166.301 1.202.727 2.154 1.167 1.75.44-.402.877-.593 1.166-1.75.29-1.156.225-.167.584-1.75.359-1.584.718-1.646.718-1.646s.796-.064.908.452c.104.482.563.383.7.293.083-.054.19-.152.297-.261-.293 4.077-3.695 7.306-7.845 7.306-.794 0-1.56-.12-2.284-.34.03-1.994-1.788-2.531-1.828-2.885-.061-.54-1.192-1.162-1.75-1.167-.56-.005-.204-1.338-.584-1.75-.199-.215-.7.094-1.122.422a7.846 7.846 0 0 1-.286-1.727c.426-.274.94-.614.963-1.01.016-.262.462-.648.444-.603-.018.045.598-1.35.583-1.75-.014-.4-.24-.943 0-1.75.072-.243.134-.506.186-.758a7.89 7.89 0 0 1 2.91-1.92 2.207 2.207 0 0 1-.3.805c-.062.1-.908 1.481-.462 1.288.718-.31 1.565-.496 2.335-.583.77-.087-.081-.892 0-1.166.037-.126.291-.478.555-.823A7.75 7.75 0 0 1 9 1.125c1.251 0 2.431.3 3.482.822Z"
  })));
};
exports.SpotGlobe = SpotGlobe;
SpotGlobe.displayName = "SpotGlobe";